import React from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'

import { useToast } from '@sketch/toasts'

import {
  Button,
  Form,
  Modal,
  Input,
  PasswordInput,
  ModalInjectedProps,
} from '@sketch/components'

import { Title, Description } from './SocialSignInMFAModal.styles'

// GQL

type FormValues = typeof INITIAL_VALUES

const INITIAL_VALUES = {
  email: '',
  password: '',
}

const VALIDATION_SCHEMA = yup.object().shape({
  email: yup
    .string()
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup.string().required("Password can't be blank"),
})

export const SocialSignInMFAModal: React.FC<ModalInjectedProps> = ({
  hideModal,
}) => {
  const { showToast } = useToast()

  const handleSubmit = (values: FormValues) => {
    showToast('TODO: Handle MFA enable with Socials', 'negative')
  }

  // TODO: Remove this and replace with mutation loading
  const loading = false

  return (
    <Modal onCancel={hideModal}>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, dirty }) => (
          <Form>
            <Modal.Body>
              <Title>Enable Two-Factor Authentication (2FA)</Title>
              <Description>
                You’ll need to add a “Email + Password” login method to your
                account to enable Two-Factor Authentication.
              </Description>

              <Form.Field
                name="email"
                label="Email"
                errorText={touched.email ? errors.email : undefined}
              >
                <Input
                  name="email"
                  type="email"
                  value={values.email}
                  placeholder="Email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Form.Field>

              <Form.Field
                name="password"
                label="Password"
                errorText={touched.password ? errors.password : undefined}
              >
                <PasswordInput
                  name="password"
                  value={values.password}
                  placeholder="Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Form.Field>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={hideModal} disabled={loading} size="40">
                Cancel
              </Button>
              <Button
                type="submit"
                variant="primary"
                loading={loading}
                disabled={!dirty || loading}
                size="40"
              >
                Enable 2FA
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}
